export default {
  forgot_password_confirm: {
    title: '重設密碼',
    required_code: '代碼為必填項目。',
    required_password: '密碼為必填項目。',
    max_length_16: '密碼必須為8～16位數。',
    // no_blank: "",
    no_password_match: '密碼不一致。',
    reset_password: '重設密碼',
    caution: '請暫時勿關閉畫面',
    double_check_text: '@:login.double_check_text',
    password_reset_text: '已寄送確認郵件到所輸入的電子郵件信箱中，請在以下格式中輸入確認代碼之後設定新密碼。',
    verification_code: '確認代碼',
    mail_send_code: '代碼已寄送',
    password: '密碼',
    new_password: '新密碼',
    password_display: '顯示密碼',
    password_no_display: '不顯示密碼',
    password_check: '新密碼（確認）',
    submit: '設定',
  },
}
